import React from 'react';
import { Box, Container, Stack, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import instagramLogo from '../assets/insta_logo.png';
import tiktokLogo from '../assets/tiktok_logo.png';
import nameLogoSvg from '../assets/name_logo.svg';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#fff',
        color: '#111827',
        borderTop: '1px solid rgba(15, 23, 42, 0.08)',
        mt: 'auto',
        px: 2,
        position: 'relative',
        minHeight: { xs: 'auto', md: '20rem' },
      }}
    >
      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 }, position: 'relative', pb: { xs: 4, md: 6 } }}>
        {/* Mobile: Stack all sections vertically */}
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={nameLogoSvg}
            alt="Rinovo"
            sx={{
              height: { xs: '5rem', sm: '7rem' },
              width: 'auto',
              display: 'block',
            }}
          />
          
          {/* Social Icons */}
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
            <MuiLink
              href="https://www.instagram.com/rinovo.co/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'inline-flex' }}
            >
              <Box
                component="img"
                src={instagramLogo}
                alt="Instagram"
                sx={{ height: 36, width: 'auto', objectFit: 'contain' }}
              />
            </MuiLink>
            <MuiLink
              href="https://www.tiktok.com/@rinovoco?lang=en"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'inline-flex' }}
            >
              <Box
                component="img"
                src={tiktokLogo}
                alt="TikTok"
                sx={{ height: 36, width: 'auto', objectFit: 'contain' }}
              />
            </MuiLink>
          </Stack>
          
          {/* Copyright */}
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © 2025 • All Rights Reserved
          </Typography>
          
          {/* Navigation Links */}
          <Stack direction="column" spacing={1} alignItems="center">
            <MuiLink
              component={Link}
              to="/privacy"
              sx={{
                color: '#111827',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Privacy
            </MuiLink>
            <MuiLink
              component={Link}
              to="/terms"
              sx={{
                color: '#111827',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Terms
            </MuiLink>
            <MuiLink
              component={Link}
              to="/contact"
              sx={{
                color: '#111827',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Contact
            </MuiLink>
            <MuiLink
              component={Link}
              to="/contact"
              sx={{
                color: '#111827',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              FAQ
            </MuiLink>
          </Stack>
        </Box>

        {/* Desktop: Logo centered, social icons left, nav links right */}
        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            position: 'relative',
            minHeight: '16rem',
          }}
        >
          {/* Centered Logo */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box
              component="img"
              src={nameLogoSvg}
              alt="Rinovo"
              sx={{
                height: '9rem',
                width: 'auto',
                display: 'block',
              }}
            />
          </Box>

          {/* Left Section: Social Icons and Copyright */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 2,
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <MuiLink
                href="https://www.instagram.com/rinovo.co/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-flex' }}
              >
                <Box
                  component="img"
                  src={instagramLogo}
                  alt="Instagram"
                  sx={{ height: 36, width: 'auto', objectFit: 'contain' }}
                />
              </MuiLink>
              <MuiLink
                href="https://www.tiktok.com/@rinovoco?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-flex' }}
              >
                <Box
                  component="img"
                  src={tiktokLogo}
                  alt="TikTok"
                  sx={{ height: 36, width: 'auto', objectFit: 'contain' }}
                />
              </MuiLink>
            </Stack>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              © 2025 • All Rights Reserved
            </Typography>
          </Box>

          {/* Right Section: Navigation Links */}
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            <Stack direction="column" spacing={1} alignItems="flex-end">
              <MuiLink
                component={Link}
                to="/privacy"
                sx={{
                  color: '#111827',
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Privacy
              </MuiLink>
              <MuiLink
                component={Link}
                to="/terms"
                sx={{
                  color: '#111827',
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Terms
              </MuiLink>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  color: '#111827',
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Contact
              </MuiLink>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  color: '#111827',
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                FAQ
              </MuiLink>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

